var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GekkoButton',{staticClass:"display-none",attrs:{"text":_vm.$gettext('Open premium congrats'),"variant":"link text-blue","icon":'fa-solid fa-sparkles',"icon-right":""},on:{"click":_vm.openPremiumCongrats}})}
var staticRenderFns = []

export { render, staticRenderFns }